module.exports = __webpack_public_path__ + "static/media/Clerk_FCCC_CiviTek_Story-v2_1614783375407.27738d8d.docx";